module.exports = __webpack_public_path__ + "img/icon_item_active.d6412e97.png";